export async function index({commit}) {

  const {errResponse, data: responseData} = await this.$frontendRepositories.papers.index();

  if (!errResponse && responseData.success) {
    const relatedPapers = responseData.data.map((element) => {
      return {
        id : element.model_class + String(element.id),
        key: element.id,
        paperable_id: element.id,
        title: element.title,
        name: element.title,
        paperable_type: element.model_class,
        id_encrypt: element.id_encrypt ?? '',
        application_user: element.hasOwnProperty('application_user') && element.application_user 
          ? element.application_user[0] : [],
      }
    });
    return commit('setPapers', relatedPapers);
  }

  return [];
}
